<style>
    nav {
        width: calc(100% - 120px);
        padding: 40px 0 0 60px;
        display: flex;
        justify-content: space-between;
    }

    img {
        height: 24px;
        transition: all 0.3s ease-in-out;
    }

    button {
        cursor: pointer;
        background: none;
        border: none;
        text-align: center;
        color: white;
        margin-left: 8px;
        padding: 4px 12px;
        border-radius: 4px;
        transition: all 0.3s;
    }

    button:hover {
        background: white;
        color: #EA4C09;
        box-shadow: 4px 8px 20px rgba(215, 74, 9, 0.4);
    }

    button:active {
        transform: translateY(2px);
        transition: all 0.1s ease-out;
    }

    @media screen and (max-width: 768px) {
        nav {
            width: calc(100% - 40px);
            min-height: 40px;
            padding: 20px 20px 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        img {
            height: 18px;
        }

        button {
            margin: 0;
            padding: 4px;
        }
    }

</style>

<script>

    import ModalService from "../services/ModalService";

    function share() {
        ModalService.share();
    }

    function about() {
        ModalService.about();
    }

</script>

<nav>
    <a href="/">
        <img src="images/logo-burnlink.svg" alt="BURN.link Logo">
    </a>
    <div>
        <button on:click={share}><h2>Share</h2></button>
        <button on:click={about}><h2>About</h2></button>
    </div>
</nav>